import React from "react";
import * as S from './style';
import { useEffect, useState } from 'react';
import { handleGetData } from "../../../../Api";
import { useStartupState } from "../../../../Providers/StartupState";


const CopasulCouncil = () => {
  const [data, setData] = useState(null);
  const { token, setError } = useStartupState();

  useEffect(() => {
    setError(null);
    if (token) {
      handleGetData(token, 'api/content/copasul/governanca/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
        })
    }
  }, [token, setError])

  return (
    <>
      <S.HexagonWrapper>
        <S.HexagonInner>
          <S.HexagonText>
            {data?.ConselhoCopasul?.iv?.conselho?.iv[0]?.nome}
          </S.HexagonText>

          <S.SmallHexagonText>
            {data?.ConselhoCopasul?.iv?.conselho?.iv[0]?.membros?.map((membro, index) => (
              <div key={index}>
                {membro}
              </div>
            ))}
          </S.SmallHexagonText>

        </S.HexagonInner>
      </S.HexagonWrapper>

      <S.ConnectionLine>
        <div className="line-vertical" />
        <div className="line-horizontal" />
        <div className="line-second-horizontal" />
      </S.ConnectionLine>

      <S.HexagonRow>
        <S.SmallHexagonWrapperD>
          <S.SmallHexagonInner>
            <S.HexagonText>{data?.ConselhoCopasul?.iv?.conselho?.iv[1]?.nome}</S.HexagonText>
            <S.SmallHexagonText>
            {data?.ConselhoCopasul?.iv?.conselho?.iv[1]?.membros?.map((membro, index) => (
              <div key={index}>
                {membro}
              </div>
            ))}
          </S.SmallHexagonText>
          </S.SmallHexagonInner>
        </S.SmallHexagonWrapperD>

        <S.SmallHexagonWrapperE>
          <S.SmallHexagonInner>
            <S.HexagonText>{data?.ConselhoCopasul?.iv?.conselho?.iv[2]?.nome}</S.HexagonText>
            <S.SmallHexagonText>
            {data?.ConselhoCopasul?.iv?.conselho?.iv[2]?.membros?.map((membro, index) => (
              <div key={index}>
                {membro}
              </div>
            ))}
          </S.SmallHexagonText>
          </S.SmallHexagonInner>
        </S.SmallHexagonWrapperE>
      </S.HexagonRow>
    </>
  );
};

export default CopasulCouncil;